<template>
    <div v-if="body_show">
        <!-- 我的头部 -->
        <public-top :headimgurl="headimgurl" :nickname="nickname"></public-top>
        <!-- 账户余额 -->
        <div class="money-box">
            <h3>可提现金额</h3>
            <h2><span>¥</span>{{money}}</h2>
            <van-button v-if="ajax_loading || !can_transfers()" class="btn on" type="default"  @click="withdrawalHandle()" >提现</van-button>
            <van-button v-else class="btn" type="default"  @click="withdrawalHandle()" :disabled="ajax_loading || !can_transfers()">提现</van-button>
        </div>
        <!--  -->
        <div v-if="cashNo.length>0" class="isPay">
            <p>课程的推荐金提取时间是开课10天后</p>
            <p v-for="(item,index) in cashNo" :key="index">{{item.unlock}}之后可提现{{item.cashno}}</p>
        </div>
    </div>
</template>

<script>
import { myaccount,transfers } from "@/api/person"
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            body_show:false,
            data:{},
            headimgurl: '',
            nickname: '',
            money:0,
            ajax_loading: false,
            cashNo:[]
        }
    },
    methods:{
        pullData() {
            //调用加载中
            this.$emit('loadingHandle',true,"拼命加载中...");
            myaccount().then(data => {
                this.body_show = true;
                this.data = data;
                this.headimgurl = data.headimg;
                this.nickname = data.nickname;
                this.money = data.total;
                this.cashNo = data.cashNo;
                //关闭加载中
                this.$emit('loadingHandle',false);
            });
        },
        withdrawalHandle(){
            if(!this.can_transfers()) {
                this.$dialog.alert({
                    message: '可提现金额不足'
                });
                return false;
            }
            this.http_request();
        },
        can_transfers(){
            return parseFloat(this.money) >= 1;
        },
        http_request(){
            let data = this.data;
            if(this.ajax_loading) {
                return false;
            }
            this.ajax_loading = true;
            transfers({
                data:data|| {}
            })
            .then(data => {
                this.ajax_loading = false;
                if(data.error === 0) {
                    this.$dialog.alert({
                        message: '提现成功！'
                    }).then(() => {
                        this.pullData();
                    });
                    // this.money = 0;
                } else {
                    this.$dialog.alert({
                        message: data.msg || '操作失败'
                    });
                }
            })
            .catch(error => {
               this.$dialog.alert({
                    message: '请求失败！'
                });
            })
        }
    },
    created() {
      this.pullData();
      shareCon("index",this);
    }
}
</script>

<style lang="scss" scoped>
    .money-box{
        padding: 40px 56px;
        border-radius:8px;
        margin: 30px 30px;
        background: #fff;
        text-align: center;
        h3{
            font-size:26px;
            color: #999999;
            line-height: 1;
        }
        h2{
            font-size: 54px;
            color: #F57F17;
            line-height: 1;
            margin: 20px auto 40px;
            span{
                font-size: 34px;
            }
        }
    }
    .isPay{
        margin: 0 30px 0;
        padding: 0 56px;
        line-height: 42px;
        p{
            font-size:26px;
            color: #999999;
        }
    }
</style>
<style lang="scss">
    .money-box .btn{
        width:578px;
        height:80px;
        background:rgba(235,80,50,1);
        color: #fff;
        border-radius:8px;
    }
    .money-box .btn.on{
        background-color: #cccccc;
    }
</style>

